import { Bodies } from 'matter-js'
import { CollisionCategory, CollisionGroup } from './rooms/room-physics-base'

const defaultOptions = {
  frictionAir: 0.09,
  restitution: 0,
  friction: 0.3,

  collisionFilter: {
    category: CollisionCategory.Coins,
    group: CollisionGroup.InactiveCoins,
    mask: CollisionCategory.Coins | CollisionCategory.StaticWallsBack
  }, ////only collide with BACK colliders (2) and coins with group 1
  render: {
    lineWidth: 3,
    fillStyle: 'transparent'
  }
}

class PhysicsFactory {
  createCircle(radius: number) {
    return Bodies.circle(0, 0, radius, defaultOptions)
  }

  createTriangle(radius: number) {
    const sides = 3
    return Bodies.polygon(0, 0, sides, radius, {
      chamfer: { radius: 15 },
      ...defaultOptions
    })
  }

  createHexagon(radius: number) {
    const sides = 6
    return Bodies.polygon(0, 0, sides, radius, {
      chamfer: { radius: 15 },
      ...defaultOptions
    })
  }

  createRhombus(radius: number) {
    const shape = Bodies.polygon(0, 0, 4, radius, { chamfer: { radius: 15 } })
    //Body.rotate(shape, Math.PI * 0.25)
    //Body.scale(shape, 1, 3)
    //Vertices.rotate(shape.vertices, Math.PI * -0.25, { x: 0, y: 0 })

    const shapeCopy = Bodies.fromVertices(0, 0, [shape.vertices], defaultOptions)

    return shapeCopy
  }
}

export default new PhysicsFactory()
